export default "__VITE_ASSET__CY8eVu7A__"